exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resultItem[data-v-6b1ec844]{margin-top:40px;margin-bottom:40px}.title[data-v-6b1ec844]{font-size:24px;margin-bottom:0}.resultValue[data-v-6b1ec844]{font-size:24px}.resultImage[data-v-6b1ec844]{text-align:center}.percentageCircle[data-v-6b1ec844]{width:100px;height:100px;border-radius:50%;background:#9acd32;position:relative;vertical-align:middle;display:inline-block}.resultImageIcon[data-v-6b1ec844]{vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b1ec844","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Results/CprResult.vue
// module id = 318
// module chunks = 0